import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';

const SeventhSection = () => {
    return (
        <>
            <div className="text-base-100 space-y-4">
                <div className='text-2xl md:text-4xl font-bold text-center'>Compare Group Health Insurance Plans</div>
                <p className='text-center'>When it comes to health insurance, you have options for your employees. The three main types of group health insurance plans include:</p>

                <div className='flex'>
                    <FaRegCheckCircle className='mx-1 min-w-20 md:mx-2 mt-1 text-4xl text-secondary' />
                    <div>
                        <div className='text-xl font-bold'>Preferred Provider Organization (PPO)</div>
                        <p>Group health insurance for self-employed business owners is available in some states. If you may be eligible to get group health insurance with no employees. States that allow you to get group insurance for a small group of 1 do so on a guaranteed-issue basis. Therefore, you do not have to worry whether you qualify for coverage.</p>
                    </div>
                </div>

                <div className='flex'>
                    <FaRegCheckCircle className='mx-1 min-w-20 md:mx-2 mt-1 text-4xl text-secondary' />
                    <div>
                        <div className='text-xl font-bold'>Health Maintenance Organization (HMO)</div>
                        <p>If you hire at least one employee who is not a spouse, co-owner, business partner, or independent contractor, you can buy group health insurance through your Insurance Enterprise agent. There are a variety of insurance plans available for all types of small businesses and larger corporations with 50 or fewer employees.</p>
                    </div>
                </div>

                <div className='flex'>
                    <FaRegCheckCircle className='mx-1 min-w-20 md:mx-2 mt-1 text-4xl text-secondary' />
                    <div>
                        <div className='text-xl font-bold'>Point of Service Plan (POS)</div>
                        <p>A POS contains a combination of features from both HMOs and PPOs. Premiums are typically in a price range between the other two plans. The healthcare provider network in a point of service plan can vary depending on the provider.
                            When choosing a health insurance plan, assess your needs, compare your options, and complete the enrollment process. Insurance Enterprise makes it easy by completing many of the steps for you.</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SeventhSection;
